<input #inputValue type="{{type}}"  value="{{value}}" style="width: 100%"  class="form-control">
